/**
 * Companion timers intentionally differ from regular React/Sequence timers:
 * iOS exposes delay from 0 through 10 seconds, and prompt as Solid (0) plus
 * 0.1 through 10 seconds. Dynamic (-1) is not a Companion option.
 */
export const COMPANION_DELAY_OPTIONS: readonly number[] = Array.from(
  {length: 101},
  (_, index) => index / 10,
);

export const COMPANION_PROMPT_OPTIONS: readonly number[] = Array.from(
  {length: 101},
  (_, index) => index / 10,
);
